import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import FolderIcon from '~/assets/icons/content-qr/folder.svg?react';
import KeyIcon from '~/assets/icons/content-qr/key.svg?react';
import SettingsIcon from '~/assets/icons/content-qr/settings.svg?react';
import ContentIcon from '~/assets/icons/svgs/content.svg?react';
import InfoIcon from '~/assets/icons/svgs/info-outlined.svg?react';
import PalleteIcon from '~/assets/icons/svgs/pallete.svg?react';
import Accordion from '~/components/ui/Accordion/Accordion';
import { Text } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';

import { useStyles } from './CreateQRContentBlockLayout.styles';

const CONTENT_MAP = {
  basicInfo: {
    title: 'basicTemplateLabels:basicInfoTitle',
    subtitle: 'basicTemplateLabels:basicInfoSubTitle',
    icon: <InfoIcon />,
  },
  appearance: {
    title: 'basicTemplateLabels:appearanceTitle',
    subtitle: 'basicTemplateLabels:appearanceSubTitle',
    icon: <PalleteIcon />,
  },
  content: {
    title: 'basicTemplateLabels:contentTitle',
    subtitle: 'basicTemplateLabels:contentSubTitle',
    icon: <ContentIcon />,
  },
  nameAndOrganization: {
    title: 'basicTemplateLabels:nameAndOrganisation.title',
    subtitle: 'basicTemplateLabels:nameAndOrganisation.description',
    icon: <FolderIcon />,
  },
  passwordProtection: {
    title: 'basicTemplateLabels:passwordProtection.title',
    subtitle: 'basicTemplateLabels:passwordProtection.description',
    icon: <KeyIcon />,
  },
  settings: {
    title: 'basicTemplateLabels:settings',
    subtitle: 'basicTemplateLabels:statsSubTitle',
    icon: <SettingsIcon />,
  },
};

type CreateQRContentBlockLayoutProps = {
  defaultExpanded?: boolean;
  type: 'basicInfo' | 'appearance' | 'content' | 'settings' | 'nameAndOrganization' | 'passwordProtection';
};
export default function CreateQRContentBlockLayout({
  children,
  type,
  defaultExpanded = true,
}: PropsWithChildren<CreateQRContentBlockLayoutProps>) {
  const { t } = useTranslation();

  const styles = useStyles();

  const content = CONTENT_MAP[type];

  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      variant="medium"
      summary={
        <Box sx={styles.header}>
          <Box sx={styles.iconContainer}>{content.icon}</Box>
          <div>
            <Text variant="h3">{t(content.title)}</Text>
            <Text variant="input15" sx={{ color: COLORS.grey400 }}>
              {t(content.subtitle)}
            </Text>
          </div>
        </Box>
      }
      details={children}
    />
  );
}
